import script from "./BasicList2.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicList2.vue?vue&type=script&setup=true&lang=js"

import "./BasicList2.vue?vue&type=style&index=0&id=279c226c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279c226c"]])

export default __exports__